import Vue from "vue";
import RCLoading from "./RCLoading.vue";

// 1. 创建组件构造器（Vue2 核心 API）
const RCLoadingConstructor = Vue.extend(RCLoading);

// 2. 创建单例实例（避免重复创建多个 Loading）
let rcLoadingInstance = null;
function createInstance() {
  if (!rcLoadingInstance) {
    rcLoadingInstance = new RCLoadingConstructor();
    // 挂载到 DOM（创建一个空 div 作为挂载点）
    rcLoadingInstance.$mount(document.createElement("div"));
    // 将组件 DOM 插入 body
    document.body.appendChild(rcLoadingInstance.$el);
  }
  return rcLoadingInstance;
}

// 3. 封装全局调用方法
const RcLoading = {
  // 显示 Loading
  show: (text) => {
    const instance = createInstance();
    instance.show(text);
  },
  // 隐藏 Loading
  hide: () => {
    if (rcLoadingInstance) {
      rcLoadingInstance.hide();
    }
  },
};

// 4. 挂载到 Vue 原型（供 Vue 页面通过 this.$RCLoading 调用）
Vue.prototype.$RCLoading = RcLoading;

// 5. 导出（供 request.js 等纯 JS 文件调用）
export default RCLoading;


// WEBPACK FOOTER //
// ./src/common/RCLoading/RCLoading.js